import React from 'react';
import { Bell, Search } from 'lucide-react';
import { useAuthStore } from '../../store/authStore';

interface HeaderProps {
  title: string;
}

export function Header({ title }: HeaderProps) {
  const { user } = useAuthStore();

  return (
    <header className="flex items-center justify-between border-b border-[#D0D4E4] bg-white px-6 py-4">
      <h1 className="text-2xl font-bold text-[#323338]">{title}</h1>

      <div className="flex items-center gap-4">
        {/* Search */}
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#676879]" />
          <input
            type="text"
            placeholder="Buscar..."
            className="w-64 rounded border border-transparent bg-[#F5F7FB] py-2 pl-9 pr-4 text-sm text-[#323338] placeholder:text-[#8C91A3] focus:border-[#C24914] focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#edc6b5]"
          />
        </div>

        {/* Notifications */}
        <button className="relative rounded p-2 text-[#676879] transition-colors hover:bg-[#F5F7FB] hover:text-[#C24914]">
          <Bell size={20} />
          <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-[#C24914]"></span>
        </button>

        {/* Avatar */}
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[#C24914] text-sm font-bold text-white">
          {user?.name?.charAt(0).toUpperCase()}
        </div>
      </div>
    </header>
  );
}
